"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PagingModel = function (_Observer) {
    _inherits(PagingModel, _Observer);

    /**
     * Spalte für Sortierung
     * @type {string}
     */


    /**
     * 
     * Start der Liste
     * @type {integer}
     */
    function PagingModel(observers, id, request) {
        _classCallCheck(this, PagingModel);

        var _this = _possibleConstructorReturn(this, (PagingModel.__proto__ || Object.getPrototypeOf(PagingModel)).call(this, observers, id, request));

        _this.Count = 0;
        _this.Start = 0;
        _this.Limit = 0;
        _this.OrderColumn = "";
        _this.OrderDirection = "";
        return _this;
    }

    /**
     * Sortierrichtung
     * @type {string}
     */


    /**
     * Ende Liste
     * @type {integer}
     */

    /**
     * Anzahl Verträge
     * @type {integer}
     */


    _createClass(PagingModel, [{
        key: "setSendData",
        value: function setSendData(senddata, start, limit, orderColumn, orderDirection, statusId, contractNumber, dateFrom, dateTo, terminationDate, beanstanShortcut, paymentMethodValue, deadLine, customerCategory, firstName, lastName, street, postcode, city, customerNumber, email, regNr, emailNew, validFrom, checkAdministratorAbove, customerAboveId) {
            var reqString = '';
            if (senddata === null || senddata === undefined) {
                var paramsCount = 0;
                var params = [];
                if (start !== null && start !== undefined) {
                    paramsCount++;
                    params.push({ Param: "start", Value: start });
                }
                if (limit !== null && limit !== undefined) {
                    paramsCount++;
                    params.push({ Param: "limit", Value: limit });
                }
                if (orderColumn !== null && orderColumn !== undefined) {
                    paramsCount++;
                    params.push({ Param: "orderColumn", Value: orderColumn });
                }
                if (orderDirection !== null && orderDirection !== undefined) {
                    paramsCount++;
                    params.push({ Param: "orderDirection", Value: orderDirection });
                }
                if (statusId !== null && statusId !== undefined) {
                    paramsCount++;
                    params.push({ Param: "statusId", Value: statusId });
                }
                if (contractNumber !== null && contractNumber !== undefined) {
                    paramsCount++;
                    params.push({ Param: "contractNumber", Value: contractNumber });
                }
                if (dateFrom !== null && dateFrom !== undefined) {
                    paramsCount++;
                    params.push({ Param: "dateFrom", Value: dateFrom });
                }
                if (dateTo !== null && dateTo !== undefined) {
                    paramsCount++;
                    params.push({ Param: "dateTo", Value: dateTo });
                }
                if (terminationDate !== null && terminationDate !== undefined) {
                    paramsCount++;
                    params.push({ Param: "terminationDate", Value: terminationDate });
                }
                if (beanstanShortcut !== null && beanstanShortcut !== undefined) {
                    paramsCount++;
                    params.push({ Param: "beanstanShortcut", Value: beanstanShortcut });
                }
                if (paymentMethodValue !== null && paymentMethodValue !== undefined) {
                    paramsCount++;
                    params.push({ Param: "paymentMethodValue", Value: paymentMethodValue });
                }
                if (deadLine !== null && deadLine !== undefined) {
                    paramsCount++;
                    params.push({ Param: "deadLine", Value: deadLine });
                }
                if (customerCategory !== null && customerCategory !== undefined) {
                    paramsCount++;
                    params.push({ Param: "customerCategory", Value: customerCategory });
                }
                if (firstName !== null && firstName !== undefined) {
                    paramsCount++;
                    params.push({ Param: "firstName", Value: firstName });
                }
                if (lastName !== null && lastName !== undefined) {
                    paramsCount++;
                    params.push({ Param: "lastName", Value: lastName });
                }
                if (street !== null && street !== undefined) {
                    paramsCount++;
                    params.push({ Param: "street", Value: street });
                }
                if (postcode !== null && postcode !== undefined) {
                    paramsCount++;
                    params.push({ Param: "postcode", Value: postcode });
                }
                if (city !== null && city !== undefined) {
                    paramsCount++;
                    params.push({ Param: "city", Value: city });
                }
                if (customerNumber !== null && customerNumber !== undefined) {
                    paramsCount++;
                    params.push({ Param: "customerNumber", Value: customerNumber });
                }
                if (email !== null && email !== undefined) {
                    paramsCount++;
                    params.push({ Param: "email", Value: email });
                }
                if (regNr !== null && regNr !== undefined) {
                    paramsCount++;
                    params.push({ Param: "regNr", Value: regNr });
                }
                if (emailNew !== null && emailNew !== undefined) {
                    paramsCount++;
                    params.push({ Param: "emailNew", Value: emailNew });
                }
                if (validFrom !== null && validFrom !== undefined) {
                    paramsCount++;
                    params.push({ Param: "validFrom", Value: validFrom });
                }
                if (checkAdministratorAbove !== null && checkAdministratorAbove !== undefined) {
                    paramsCount++;
                    params.push({ Param: "checkAdministratorAbove", Value: checkAdministratorAbove });
                }
                if (customerAboveId !== null && customerAboveId !== undefined) {
                    paramsCount++;
                    params.push({ Param: "customerAboveId", Value: customerAboveId });
                }
                if (paramsCount > 0) {
                    reqString += "?";
                    for (var i = 0; i < params.length; i++) {
                        reqString += params[i].Param + "=" + params[i].Value;
                        if (i < paramsCount - 1) {
                            reqString += '&';
                        }
                    }
                }
            } else {
                reqString += senddata;

                var _paramsCount = 0;
                var _params = [];
                if (statusId !== null && statusId !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "statusId", Value: statusId });
                }
                if (contractNumber !== null && contractNumber !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "contractNumber", Value: contractNumber });
                }
                if (dateFrom !== null && dateFrom !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "dateFrom", Value: dateFrom });
                }
                if (dateTo !== null && dateTo !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "dateTo", Value: dateTo });
                }
                if (terminationDate !== null && terminationDate !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "terminationDate", Value: terminationDate });
                }
                if (beanstanShortcut !== null && beanstanShortcut !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "beanstanShortcut", Value: beanstanShortcut });
                }
                if (paymentMethodValue !== null && paymentMethodValue !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "paymentMethodValue", Value: paymentMethodValue });
                }
                if (deadLine !== null && deadLine !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "deadLine", Value: deadLine });
                }
                if (customerCategory !== null && customerCategory !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "customerCategory", Value: customerCategory });
                }
                if (firstName !== null && firstName !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "firstName", Value: firstName });
                }
                if (lastName !== null && lastName !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "lastName", Value: lastName });
                }
                if (street !== null && street !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "street", Value: street });
                }
                if (postcode !== null && postcode !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "postcode", Value: postcode });
                }
                if (city !== null && city !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "city", Value: city });
                }
                if (customerNumber !== null && customerNumber !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "customerNumber", Value: customerNumber });
                }
                if (email !== null && email !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "email", Value: email });
                }
                if (regNr !== null && regNr !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "regNr", Value: regNr });
                }
                if (emailNew !== null && emailNew !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "emailNew", Value: emailNew });
                }
                if (validFrom !== null && validFrom !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "validFrom", Value: validFrom });
                }
                if (checkAdministratorAbove !== null && checkAdministratorAbove !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "checkAdministratorAbove", Value: checkAdministratorAbove });
                }
                if (customerAboveId !== null && customerAboveId !== undefined) {
                    _paramsCount++;
                    _params.push({ Param: "customerAboveId", Value: customerAboveId });
                }
                if (_paramsCount > 0) {
                    reqString += "&";
                    for (var _i = 0; _i < _params.length; _i++) {
                        reqString += _params[_i].Param + "=" + _params[_i].Value;
                        if (_i < _paramsCount - 1) {
                            reqString += '&';
                        }
                    }
                }
            }
            return reqString;
        }
    }, {
        key: "setResult",
        value: function setResult(result) {
            var me = this;
            if (result) {
                if (result.Data) {
                    var data = result.Data;
                    if (data.Count !== undefined && data.Count !== null) {
                        me.Count = data.Count;
                    }
                    if (data.Start !== undefined && data.Start !== null) {
                        me.Start = data.Start;
                    }
                    if (data.Limit !== undefined && data.Limit !== null) {
                        me.Limit = data.Limit;
                    }
                    if (data.OrderColumn !== undefined && data.OrderColumn !== null) {
                        me.OrderColumn = data.OrderColumn;
                    }
                    if (data.OrderDirection !== undefined && data.OrderDirection !== null) {
                        me.OrderDirection = data.OrderDirection;
                    }
                }
            }
        }
    }]);

    return PagingModel;
}(_Observer3.default);

exports.default = PagingModel;